(function ($) {

  function setActiveFilter() {
    var links = $('.filter-row-left .filter-btn[href], .filter-row-left .filter-dropdown-item[href]');
    if (links.length === 0) {
      return;
    }
    var current = window.location.pathname.replace(/index\.html$/, '') || '/';
    links.each(function () {
      var link = $(this);
      var linkPath = new URL(link.attr('href'), window.location.origin).pathname.replace(/index\.html$/, '') || '/';
      var isHome = current === '/' && linkPath === '/pubs/';
      var isPaginated = linkPath === '/pubs/' && current.indexOf('/pubs/') === 0;
      link.toggleClass('is-active', linkPath === current || isHome || isPaginated);
    });
    $('#filter-more-toggle').toggleClass('is-active', $('.filter-dropdown-menu .is-active').length > 0);
  }

  function setFilterDropdown() {
    var dropdown = $('#filter-more');
    if (dropdown.length === 0) {
      return;
    }
    var toggle = dropdown.find('#filter-more-toggle');
    toggle.on('click', function (e) {
      e.stopPropagation();
      var isOpen = dropdown.toggleClass('is-open').hasClass('is-open');
      toggle.attr('aria-expanded', isOpen);
    });
    $(document).on('click', function (e) {
      if (!$(e.target).closest(dropdown).length) {
        dropdown.removeClass('is-open');
        toggle.attr('aria-expanded', false);
      }
    });
    $(document).on('keydown', function (e) {
      if (e.key === 'Escape') {
        dropdown.removeClass('is-open');
        toggle.attr('aria-expanded', false);
      }
    });
  }

  window.mypubs.setRatings();
  window.mypubs.setStatuses();
  window.mypubs.setMaps();
  setActiveFilter();
  setFilterDropdown();

})(jQuery);